module.exports = __webpack_public_path__ + "lp/img/arrow_right_white.d2cf3da7.svg";